'use client'

import type { HTMLAttributes } from "react"
import classNames from "classnames"

import { useTranslations } from "../hooks/use-translations"
import type { Icons } from "./assets/dustin-icons-type"

interface Props extends HTMLAttributes<HTMLElement> {
  name: Icons
  className?: string
}

/**
 * Renders an icon using a font-based icon set.
 *
 * This component will apply the provided icon `name` as a CSS class
 * along with any additional `className` specified.
 *
 * You **must** ensure that the corresponding icon font CSS is imported
 * first in the app for the icons to be displayed.
 */
const Icon = ({ name, className, ...props }: Props) => {
  const { translate } = useTranslations()

  return (
    <i
      {...props}
      role="img"
      className={classNames(`icon-${name}`, className)}
      aria-label={props['aria-label'] || translate(`Icon_AriaLabel_${name}`)}>
    </i>
  )
}

export default Icon
